import * as React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalChildStyle } from './modal';
import { style } from 'typestyle';
import {
  betweenJustified, endJustified, horizontal, horizontallySpaced, start, startJustified, vertical,
  verticallySpaced
} from 'csstips';
import { ButtonPill } from './button-pill';
import { colorBrand, colorContrast, colorSlate, colorSubtle, colorWhite } from '../theme/color';
import { resetAnchorStyles } from '../theme/reset';
import { em, percent, px } from 'csx';
import {TrackSchema} from '../types/schema';

export interface RestrictedModalModel {
  show: boolean;
}

export interface RestrictedModalProps {
  model: RestrictedModalModel;
  onRequestClose(): void;
}

@observer
export class RestrictedModal extends React.Component<RestrictedModalProps, any> {
  render() {
    const { model, onRequestClose } = this.props;

    return (
      <Modal show={model.show} onRequestClose={onRequestClose}>
        {model.show && (
          <div className={RestrictedModal.styles.container}>
            <h3>Track restricted</h3>
            <p>
              Well this is awkward… We’re not allowed to license this track in your country – sorry! International
              copyright rules suck sometimes, but there are plenty more fish in the sea, keep browsing to find your
              perfect track.
            </p>
            <div className={RestrictedModal.styles.buttons}>
              <ButtonPill onClick={onRequestClose}>
                Close
              </ButtonPill>
            </div>
          </div>
        )}
      </Modal>
    )
  }

  static styles = {
    container: style(ModalChildStyle, {
      ...ModalChildStyle,
      width: px(420),
      maxWidth: 'calc(100vw - 4rem)',
      background: colorSlate.toString(),
      overflowX: 'hidden',
      $nest: {
        '&> h3': {
          color: colorContrast.toString(),
          fontSize: px(30),
          margin: '0 0 30px 0',
        },
        '& p': {
          color: colorWhite.toString(),
          margin: '5px 0 30px 0',
          lineHeight: em(1.4)
        }
      }
    }),
    link: style({
      color: colorBrand.toString(),
      $nest: { ...resetAnchorStyles(colorBrand.toString()) }
    }),
    buttons: style({
      ...horizontal,
      ...horizontallySpaced(10),
      ...endJustified,
      margin: '30px 0 0 0'
    }),
    buttonsLicense: style({
      ...vertical,
      ...verticallySpaced(10),
      ...startJustified,
      ...start,
      margin: 0
    }),
    button: style({
      ...horizontal,
      ...betweenJustified,
      width: percent(100),
    }),
    loading: style({
      padding: px(30),
      textAlign: 'center',
      color: colorSubtle.toString()
    }),
    discount: style({
      textDecoration: 'line-through',
      marginRight: px(5),
    })
  };
}